import { createFileRoute } from "@tanstack/react-router";
import {
	drawerFormSearch,
	redirectLegacyEntityTypeForm,
} from "@/features/form-editor/lib/redirect-legacy-entity-type-form";

const ROUTE_ID =
	"/_authenticated/(admin-app)/_admin/admin/configuration/ticketTypes/$ticketTypeId/form" as const;

export const Route = createFileRoute(ROUTE_ID)({
	beforeLoad: ({ location, params, search }) => {
		redirectLegacyEntityTypeForm({
			pathname: location.pathname,
			typeId: params.ticketTypeId,
			to: "/admin/configuration/ticketTypes/$ticketTypeId/schema",
			params: { ticketTypeId: params.ticketTypeId },
			search: drawerFormSearch(search, "full"),
		});
	},
	component: () => null,
});
